import { render } from "./CookieBanner.vue?vue&type=template&id=a8bf2248&scoped=true"
import script from "./CookieBanner.vue?vue&type=script&lang=js"
export * from "./CookieBanner.vue?vue&type=script&lang=js"

import "./CookieBanner.vue?vue&type=style&index=0&id=a8bf2248&scoped=true&lang=css"
import "./CookieBanner.vue?vue&type=style&index=1&id=a8bf2248&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8bf2248"]])

export default __exports__